import { render } from "./PlotConfig.vue?vue&type=template&id=382615dc&scoped=true"
import script from "./PlotConfig.vue?vue&type=script&lang=js"
export * from "./PlotConfig.vue?vue&type=script&lang=js"

import "./PlotConfig.vue?vue&type=style&index=0&id=382615dc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-382615dc"]])

export default __exports__